import {saveQuizDataEvent} from "../../events/saveQuizDataEvent";
import {resultsEvaluatedEvent} from "../../events/resultsEvaluatedEvent";
import {collectQuizDataEvent} from "../../events/collectQuizDataEvent";
import {showQuestionEvent} from "../../events/showQuestionEvent";

export function collectQuizData(currentQuestion) {
    let answers = saveQuizDataEvent().answers;
    let correctlyAnswered = saveQuizDataEvent().correctlyAnswered;
    let currentQuestionKey = currentQuestion.attr('data-key');
    let currentQuestionType = currentQuestion.attr('data-question-type');

    /**
     * Skip info questions
     */
    if (currentQuestionType === 'info') {
        return;
    }

    /**
     * Init answers array
     */
    answers[currentQuestionKey] = [];

    /**
     * Collect answers
     */
    if (currentQuestionType === 'open') {
        answers[currentQuestionKey].push(currentQuestion.find('textarea').val())
    } else {
        currentQuestion.find('.growtype-quiz-question-answer.is-active').map(function (index, element) {
            answers[currentQuestionKey].push($(this).attr('data-value'))
        });
    }

    /**
     * Collect correct answers
     */
    if ($('.growtype-quiz-wrapper[data-quiz-type="scored"]').length > 0 && currentQuestionType !== 'open') {
        let correctAnswer = true;
        currentQuestion.find('.growtype-quiz-question-answer').map(function (index, element) {
            if ($(this).hasClass('is-active') && $(this).attr('data-cor').length === 0) {
                correctAnswer = false;
            }
        });

        if (!correctlyAnswered[currentQuestionKey]) {
            correctlyAnswered[currentQuestionKey] = [];
        }

        correctlyAnswered[currentQuestionKey].push(correctAnswer);
    }

    /**
     * Collect inputs data
     */
    if (currentQuestion.find('input:visible,textarea:visible').length > 0) {
        let formData = window.growtype_quiz_global.files;
        currentQuestion.find('input:visible,textarea:visible').each(function (index, element) {
            if ($(element).attr('type') === 'file') {
                let formKey = currentQuestionKey + '#_#' + index + '#_#' + $(element).attr('name');
                let images = $(element)[0].files;

                for (var x = 0; x < images.length; x++) {
                    formData.append(formKey, images[x]);
                }

                window.growtype_quiz_global.files = formData;
            } else {
                answers[currentQuestionKey].push({
                    name: $(element).attr('name'),
                    value: $(element).val()
                });
            }
        })
    }

    //Delete duplicate keys
    // let keyExists = false;
    // Object.entries(answers).map(function (element) {
    //     if (keyExists) {
    //         delete answers[element[0]];
    //         console.log('delete key 1', element[0])
    //     }
    //
    //     if (element[0] === currentQuestionKey) {
    //         keyExists = true;
    //     }
    // })

    /**
     * Save unit system
     */
    if (currentQuestion.find('.unitsystem-selector-item.is-active:visible').length > 0) {
        answers['unit_system'] = currentQuestion.find('.unitsystem-selector-item.is-active').attr('data-type');
    }

    /**
     * Collect extra details
     */
    document.dispatchEvent(collectQuizDataEvent({
        currentQuestion: currentQuestion,
        answers: answers
    }));

    /**
     * Save answers to session
     */
    sessionStorage.setItem('growtype_quiz_answers', JSON.stringify(answers));

    saveQuizDataEvent().answers = answers;
}
